import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'GroupsInvites', outputIsString: true });

export { default } from './GroupsInvites';
